export default "__VITE_ASSET__YOKQPy_n__"